import { NotifyHelper } from "../../../helpers/toast";
import { ePhanPhoiDeThiActionsObj } from "../../action-types/de-thi/IPhanPhoiDeThiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const phanPhoiDeThiActions = {
  ...generateActions(ePhanPhoiDeThiActionsObj, "PHAN_PHOI_DE_THI"),
  ...generateActionForKey(
    ePhanPhoiDeThiActionsObj,
    "PHAN_PHOI_DE_THI",
    "PHAN_PHOI_SUCCESS",
    () => {
      NotifyHelper.Success("Đã phân phối đề thi");
    }
  ),
  ...generateActionForKey(
    ePhanPhoiDeThiActionsObj,
    "PHAN_PHOI_DE_THI",
    "PHAN_PHOI_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    ePhanPhoiDeThiActionsObj,
    "PHAN_PHOI_DE_THI",
    "THU_HOI_SUCCESS",
    () => {
      NotifyHelper.Success("Đã thu hồi đề thi");
    }
  ),
  ...generateActionForKey(
    ePhanPhoiDeThiActionsObj,
    "PHAN_PHOI_DE_THI",
    "THU_HOI_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
